import React from "react";
import styled from "styled-components";
import { useProductContext } from "../../context/ProductContext";
import { Link } from "react-router-dom";

const Profile = () => {
  const { c_user } = useProductContext();

  return (
    <Wrapper>
      <h2
        style={{ textAlign: "center", fontWeight: "bold", marginTop: "20px" }}
      >
        MY PROFILE
      </h2>

      <div className="d-flex  align-items-center justify-content-center ">
        <div className="profile-container col-lg-6 col-md-6 col-10">
          <img
            src={
              c_user.image
                ? `${process.env.REACT_APP_BASE_URL}${c_user.image.replace(
                    "/server/",
                    ""
                  )}`
                : "img/default_profile_pic.png"
            }
            alt="Pic"
            className="profile-image"
          />
          <p>
            <strong>Name: </strong>
            {c_user.name}
          </p>

          <p>
            <strong>Phone No: </strong>
            {c_user.email}
          </p>

          <p>
            <strong>District: </strong>
            {c_user.district}
          </p>
          <p>
            <strong>Upazila: </strong>
            {c_user.upazila}
          </p>
          <p>
            <strong>Address: </strong>
            {c_user.address}
          </p>
          <Link to={`/update-profile/${c_user.id}`}>
            <button className="normal">UPDATE PROFILE</button>
          </Link>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .profile-container {
    text-align: center;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    margin: 20px;
    background: #000;
    color: #ffff;
  }
  .profile-container p {
    color: #ffff;
  }

  .profile-image {
    width: 150px;
    height: 150px;
    border-radius: 10px;
    margin-bottom: 15px;
    border: 2px solid white;
  }
  .Pbtn {
    border-radius: 10px;
    background-color: #4caf50;
    color: white;
    padding: 10px 20px;
    font-size: 14px;
    cursor: pointer;
  }
`;

export default Profile;
